import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const LocationsListContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > :nth-child(odd) {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
